// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_leW","footer":"styles_footer__1nlIm"};